import { takeEvery, put, call, select, fork } from "@redux-saga/core/effects";
import { AnyAction } from "redux";
import { ActionResponseType } from "../../../common/types/common.types";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { RootState } from "../../../core/store";
import { GETINSPECTIONQUESTIONHISTORYDETAILS } from "./ViewInspectionQuestionHistory.action";
import { ViewInspectionQuestionHistoryType } from "./ViewInspectionQuestionHistory.types";
import { viewInspectionQuestionHistorySliceReducerActions } from "./ViewInspectionQuestionHistory.reducer";
import { getInspectionQuestionHistoryDetails } from "./ViewInspectionQuestionHistory.api";

// ==============================|| VIEWS - COMPONENTS - VIEW REMEDIATION TRACKER TASKS HISTORY - SAGA ||============================== //

const getViewInspectionQuestionHistoryWatcher = function* (): any {
  yield takeEvery(
    GETINSPECTIONQUESTIONHISTORYDETAILS,
    function* (action: AnyAction): any {
      // set page loading on
      //yield put(setLoading(true));

      const state: ViewInspectionQuestionHistoryType = yield select(
        (s: RootState) => s.viewInspectionQuestionHistoryReducer
      );

      // get data from backend
      try {
        const inspectionQuestionId: number = action.payload;

        const result: ActionResponseType = yield call(() =>
          getInspectionQuestionHistoryDetails(inspectionQuestionId)
        );
        if (!result.IsSuccess) {
          yield put(
            openPopup({
              Open: true,
              BodyText: "An error occurred when getting data",
              HeaderText: "Warning",
              PopupType: EnumPopupType.WarningPopup,
            } as PopupProps)
          );
        } else {
          if (result === null) {
            // TODO
          } else {
            const inspectionQuestionHistory: any = result.Data;
            yield put(
              viewInspectionQuestionHistorySliceReducerActions.setInspectionQuestionHistoryDetails(
                {
                  ...state,
                  InspectionQuestionHistory: inspectionQuestionHistory,
                }
              )
            );
          }
        }
      } catch (error) {
        yield put(
          openPopup({
            Open: true,
            BodyText: "An error occurred when getting data",
            HeaderText: "Warning",
            PopupType: EnumPopupType.WarningPopup,
          } as PopupProps)
        );
      }

      // set page loading on
      //yield put(setLoading(false));
    }
  );
};

const viewInspectionQuestionHistorySaga = function* () {
  yield fork(getViewInspectionQuestionHistoryWatcher);
};

export default viewInspectionQuestionHistorySaga;
